import { z } from "zod";

export const WHO_CAN_ADD_TASKS_EVERYONE = 0 as const;
export const WHO_CAN_ADD_TASKS_PM_ONLY = 1 as const;
export const WHO_CAN_ADD_TASKS_PROJECT_TEAM = 2 as const;

export const whoCanAddTasksSchema = z.union([
	z.literal(WHO_CAN_ADD_TASKS_EVERYONE),
	z.literal(WHO_CAN_ADD_TASKS_PM_ONLY),
	z.literal(WHO_CAN_ADD_TASKS_PROJECT_TEAM),
]);
export type WhoCanAddTasks = z.infer<typeof whoCanAddTasksSchema>;

/** Private projects are not workspace-wide; "everyone" means the project team. */
export const resolveWhoCanAddTasks = (isPrivate: boolean, whoCanAddTasks: WhoCanAddTasks): WhoCanAddTasks =>
	isPrivate && whoCanAddTasks === WHO_CAN_ADD_TASKS_EVERYONE ? WHO_CAN_ADD_TASKS_PROJECT_TEAM : whoCanAddTasks;

export const projectMemberRoleSchema = z.enum(["member", "manager"]);
export type ProjectMemberRole = z.infer<typeof projectMemberRoleSchema>;

export const workspaceUserRoleSchema = z.enum(["admin", "user"]);
export type WorkspaceUserRole = z.infer<typeof workspaceUserRoleSchema>;

export const TAG_TYPE = {
	Project: 0,
	Time: 1,
} as const;
export const tagTypeSchema = z.union([z.literal(TAG_TYPE.Project), z.literal(TAG_TYPE.Time)]);
export type TagType = z.infer<typeof tagTypeSchema>;

export const projectTypeSchema = z.enum(["project", "template"]);
export type ProjectType = z.infer<typeof projectTypeSchema>;

export const timeInputModeSchema = z.enum(["range", "duration"]);
export type TimeInputMode = z.infer<typeof timeInputModeSchema>;

export const workspaceTrackingModeSchema = z.enum(["workinghours", "projecthours", "allHours"]);
export type WorkspaceTrackingMode = z.infer<typeof workspaceTrackingModeSchema>;
